import type { EditableComponent } from '../../../common/model/types.tsx';

// update

export const UPDATE_EDITED_COMPONENT = 'ui.edit.UPDATE_EDITED_COMPONENT' as const;
export type UpdateEditedComponentPayload = {
	component: EditableComponent;
};
export type UpdateEditedComponentAction = {
	type: typeof UPDATE_EDITED_COMPONENT;
	payload: UpdateEditedComponentPayload;
};
export const updateEditedComponent = (
	component: EditableComponent,
): UpdateEditedComponentAction => ({
	type: UPDATE_EDITED_COMPONENT,
	payload: { component },
});

// cancel

export const CANCEL = 'ui.edit.CANCEL' as const;
export type CancelAction = {
	type: typeof CANCEL;
};
export const cancel = (): CancelAction => ({
	type: CANCEL,
});

export type Action = UpdateEditedComponentAction | CancelAction;
